<style type="text/css">
    .v-event-responsable-panel {
        position: relative;
    }

    .v-event-responsable-panel .c-header {
        display: block;
        margin: 15px auto;
        position: relative;
    }

    .v-event-responsable-panel .c-body {
        position: relative;
    }

    .v-event-responsable-panel .c-time-label {
        width: 65px;
    }

    .v-event-responsable-panel table {
        border-collapse: collapse;
        table-layout: fixed;
    }

    .v-event-responsable-panel table td, .v-event-responsable-panel table tr {
        margin: 0px;
        padding: 0px;
        height: 25px;
    }

    .v-event-responsable-panel .c-dates-container {
        position: relative;
        z-index: 2;
    }

    .v-event-responsable-panel .c-dates-container table tr {
        border-top-style: solid;
        border-top-color: #efefef;
        border-top-width: 1px;
    }

    .v-event-responsable-panel .c-dates-container table td {
        border-right-style: solid;
        border-right-color: #efefef;
        border-right-width: 1px;
        cursor: pointer;
    }

    .v-event-responsable-panel .c-dates-container table tr:hover {
    }

    .v-event-responsable-panel .c-events-container {
        position: absolute;
        top: 0;
        left: 20px;
        right: 0;
        z-index: 3;
    }

    .v-event-responsable-panel  .c-events{
        position: relative;
        height: 100%;
    }

    .v-event-responsable-panel .c-event {
        position: absolute;
        color:#fff;
        opacity: .9;
        cursor: pointer;
        border:1px solid #ffffff;
        text-wrap: avoid;
    }

    .v-event-responsable-panel .c-event-title {
        text-overflow: ellipsis;
        overflow: hidden;
        width: 80%;
        padding-left: 3px;
        white-space: nowrap;
    }

    .v-event-responsable-panel .c-event-content {
        text-overflow: ellipsis;
        overflow: hidden;
        width: 90%;
        padding-left: 3px;
        white-space: nowrap;
    }

    .v-event-responsable-panel .c-event-bg {
        z-index: 1;
        background: #fff;
        opacity: .30;
    }
</style>

<template>

    <div class="animated fadeIn">
        <b-row>
            <b-col>
                <h5>{{Core.Definition.getDefinition('Responsables')}}</h5>
                <hr/>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <Request
                        ref="requestDate"
                        :onRequestSuccess="onRequestDateSuccess"
                        root="/event-responsable-panel/date">
                    <slot slot="body">

                        <b-row>
                            <b-col>
                                <b-card>
                                    <b-row>
                                        <b-col sm="12" md="12" lg="12">
                                            <b-button @click="onTodayClick" variant="action" class="pull-left btn-square"><i class="fa fa-reply"></i>
                                            </b-button>
                                            <InputDatePicker
                                                    class="pull-left"
                                                    id="datePicker"
                                                    :isInline="false"
                                                    v-model="dataDatePicker"></InputDatePicker>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <DatePagination ref="datePagination" v-model="dataDate"></DatePagination>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-card>
                                    <div class="v-event-responsable-panel">
                                        <div class="c-header">
                                            <table width="100%">
                                                <thead>
                                                <tr>
                                                    <th class="c-time-label">
                                                    </th>
                                                    <th v-for="responsable in dataResponsables">
                                                        <div class="text-center">
                                                            <img width="100px" :src="Core.User.displayAvatar(responsable.avatar)" />
                                                            <div class="mt-2">
                                                                <strong >{{responsable.firstname}} {{responsable.lastname}}</strong>
                                                            </div>
                                                        </div>
                                                    </th>
                                                </tr>
                                                </thead>
                                            </table>
                                        </div>
                                        <div class="c-body">
                                            <div class="c-dates-container">
                                                <table width="100%">
                                                    <tbody>
                                                    <tr :key="timeIndex" v-for="time, timeIndex in dataTimes">
                                                        <td class="c-time-label">
                                                            <span v-if="timeIndex%2==0">{{time}}</span>
                                                        </td>
                                                        <td :key="dateIndex" @click="$emit('onTimeClick', date.date, time, responsableIndex)" v-for="responsable, responsableIndex in dataResponsables">&nbsp;</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="c-events-container">
                                                <table width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <td class="c-time-label"></td>
                                                        <td :key="dateIndex" class="c-date" v-for="date, dateIndex in dataDates">
                                                            <div class="c-events">
                                                                <div
                                                                        v-for="event in retrieveEvents(date.date)"
                                                                        @click="$emit('onEventClick',event, date.date)"
                                                                        :style="buildEventStyle(event, date.date)"
                                                                        class="c-event"
                                                                        :alt="renderEventAlt(event)"
                                                                        :title="renderEventAlt(event)">
                                                                    <div class="c-event-title" v-html="renderEventTitle(event)"></div>
                                                                    <div class="c-event-content" v-html="renderEventContent(event)"></div>
                                                                    <div class="c-event-bg"></div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </b-card>

                            </b-col>
                        </b-row>
                    </slot>
                </Request>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DatePagination from '../../components/DatePagination'
    import Request from '../../components/Request'
    import InputDatePicker from '../../components/InputDatePicker'

    export default {
        name: 'EventResponsablePanel',
        components: {
            DatePagination,
            Request,
            InputDatePicker
        },
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        event: {
                            defaultBGColor: '#333333',
                        },
                        date: {
                            days: 7,
                            firstDayOfWeek: 'monday',
                            displayFormat: 'dddd<br/>DD MMM YYYY'
                        },
                        time: {
                            start: '07:00',
                            end: '22:00',
                            interval: '15'
                        }
                    }
                }
            },
            value: {
                type: String,
                default: Vue.moment().format('YYYY-MM-DD')
            },
            renderEventTitle: {
                type: Function,
                default: function(event) {
                    return event.title
                }
            },
            renderEventContent: {
                type: Function,
                default: function(event) {
                    return ''
                }
            },
            renderEventAlt: {
                type: Function,
                default: function(event) {
                    return event.title
                }
            }
        },
        watch: {
            value(val) {
                this.dataDate = val
            },
            dataEvents: {
                handler(val) {
                },
                deep: true
            },
            dataDate(val) {
                this.calculateTimes()
                this.calculateDates()
                this.requestDate(val)
                this.dataDatePicker = window.Core.Value.encode(val, 'datePicker')
            },
            dataDatePicker(val) {
                val = window.Core.Value.decode(val, 'datePicker')
                this.dataDate = val
            }
        },
        mounted() {
            this.dataDate = this.value
            this.dataEvents = this.events
            this.calculateTimes()
            this.calculateDates()
            this.requestDate(this.dataDate)
        },
        data: () => {
            return {
                Core: window.Core,
                dataDatePicker: new Date(),
                dataTimes: [],
                dataDates: [],
                dataDate: Vue.moment().format('YYYY-MM-DD'),
                dataEvents: [],
                dataResponsables: []
            }
        },
        computed: {
            events: {
                set(events) {
                    this.dataEvents = events
                },
                get() {
                    return this.dataEvents
                }
            }
        },
        methods: {
            requestDate(date) {
                this.$refs.requestDate.addArg('date', date)
                this.$refs.requestDate.request()
            },
            onTodayClick() {
                this.dataDate = Vue.moment().format('YYYY-MM-DD')
            },
            onRequestDateSuccess(data) {
                if (data.responsables !== undefined) {
                    this.dataResponsables = data.responsables
                }
                if (data.eventDates !== undefined) {
                    this.dataEventDates = data.eventDates
                    this.selectEventDate(0)
                }
            },
            clearEvents() {
                this.dataEvents = []
            },
            updateEvent(event) {
                let eventIndex = Core.Array.findIndexByKey(this.dataEvents, 'id', event.id)
                if (eventIndex === false) {
                    this.dataEvents.push(event)
                } else {
                    let eventDates = Core.Array.newArray(this.dataEvents)
                    for(let eventDateIndex in eventDates) {
                        if(eventDates[eventDateIndex].id == event.id) {
                            eventDates[eventDateIndex] = event
                        }
                    }
                    this.dataEvents = []
                    this.dataEvents = eventDates
                }
            },
            calculateTimes() {
                this.dataTimes = []
                let currentDate = Vue.moment().format('YYYY-MM-DD')
                let start = Vue.moment(currentDate + 'T' + this.options.time.start).format('HH:mm')
                let end = Vue.moment(currentDate + 'T' + this.options.time.end).format('HH:mm')
                let time = start

                while (time < end) {
                    this.dataTimes.push(time)
                    time = Vue.moment(currentDate + 'T' + time).add(this.options.time.interval, 'minutes').format('HH:mm')
                }
            },
            calculateDates() {
                this.dataDates = []
                let startOf = 'isoWeek'
                if (this.options.date.firstDayOfWeek === 'sunday') {
                    startOf = 'week'
                }
                let weekStart = Vue.moment(this.dataDate).startOf(startOf).format('YYYY-MM-DD')
                let day = 0
                while (day < this.options.date.days) {
                    this.dataDates.push({
                        date: Vue.moment(weekStart).add(day, 'days').format('YYYY-MM-DD'),
                        label: Vue.moment(weekStart).add(day, 'days').format(this.options.date.displayFormat)
                    })
                    day ++
                }
            },
            retrieveEvents(date) {
                let events = []
                for (let eventIndex in this.dataEvents) {
                    let event = this.dataEvents[eventIndex]
                    if (Vue.moment(event.start).format('YYYY-MM-DD') === date) {
                        event.y = this.calcTopBottom(event)
                        events.push(event)
                    }
                }
                return events
            },
            buildEventStyle(event, date) {
                event.y = this.calcTopBottom(event)
                event.collision = this.calcCollision(event, date)
                event.x = this.calcLeftRight(event)
                let mR = 1
                if (event.collision.sameTopCount == parseInt(event.collision.sameTopPos) + 1) {
                    mR = 20
                }

                let color = Core.Color.hex(event.color, this.options.event.defaultBGColor)

                let style = 'z-index:' + event.collision.zIndex + ';background-color:' + color + ';top:' + event.y.top + 'px;bottom:-' + event.y.bottom + 'px;left:' + event.x.left + '%;right:' + event.x.right + '%;margin-right:' + mR.toString() + 'px;'
                return style
            },
            calcTopBottom (event) {
                let date = Vue.moment(event.start).format('YYYY-MM-DD')
                let timeStart = Vue.moment(date + 'T' + this.options.time.start)
                let start = Vue.moment(event.start)
                let end = Vue.moment(event.end)
                let startDiff = start.diff(timeStart, 'minutes')
                startDiff = startDiff / this.options.time.interval
                startDiff = 25 * startDiff
                var endDiff = end.diff(timeStart, 'minutes')
                endDiff = endDiff / this.options.time.interval
                endDiff = 25 * (endDiff - 1)

                return {
                    top: startDiff,
                    bottom: endDiff
                }
            },
            calcCollision (event, date) {
                let bufferBottom = 30
                let bufferTop = -50
                let events = this.retrieveEvents(date)
                let sameTopCount = 0;
                let sameTopEvents = []
                let sameTopPos = 0
                let zIndex = 0
                for (let eventIndex in events) {
                    if (event.y.top == events[eventIndex].y.top || (events[eventIndex].y.top-event.y.top >= bufferTop && events[eventIndex].y.top-event.y.top <= bufferBottom)) {
                        sameTopCount ++
                        sameTopEvents.push(events[eventIndex])
                    }
                    if (event.y.top >= events[eventIndex].y.top && event.y.top <= events[eventIndex].y.bottom) {
                        zIndex ++
                    }
                }
                for (let sameTopEventIndex in sameTopEvents) {
                    if (sameTopEvents[sameTopEventIndex].id.toString() === event.id.toString()) {
                        sameTopPos = sameTopEventIndex
                        break
                    }
                }
                return {
                    sameTopCount: sameTopCount,
                    sameTopPos: sameTopPos,
                    zIndex: zIndex
                }
            },
            calcLeftRight (event) {
                let left = 0
                let right = 0
                let sameTopCount = event.collision.sameTopCount
                let sameTopPos = event.collision.sameTopPos
                let ratio = 100 / sameTopCount

                left = ratio * parseInt(sameTopPos)
                right = 100 - (ratio * (parseInt(sameTopPos) + 1))

                return {left: left, right: right}
            }
        }
    }
</script>
